import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29d94d94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview-list rel of-hd" }
const _hoisted_2 = ["onMouseenter"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-left" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-right" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { toRef, ref, computed } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: ['list', 'index'],
  emits: ['update:index'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()


const list = toRef(props, 'list')

const w = 60 + 12
const width = computed(() => w * (list.value.length + 1) + 'px')

const step = ref(0)
const max = computed(() => list.value.length - 360 / w)

const changeStep = (n: number) => {
  if (n < 0) {
    step.value = Math.max(0, step.value + n)
  } else {
    step.value = Math.min(max.value, step.value + n)
  }
}
const transform = computed(() => `translateX(-${step.value * w}px)`)

const handleEnter = (i: number) => {
  store.commit('goods/skuImg', '')
  emit('update:index', i)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "list",
      style: _normalizeStyle({ width: _unref(width), transform: _unref(transform) })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (v, i) => {
        return (_openBlock(), _createElementBlock("label", {
          key: i,
          class: _normalizeClass({ active: i === __props.index }),
          onMouseenter: ($event: any) => (handleEnter(i))
        }, [
          _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ item: v })))
        ], 42, _hoisted_2))
      }), 128))
    ], 4),
    _createElementVNode("div", {
      class: "arrow btn arrow-left flex-center",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeStep(-1)))
    }, _hoisted_4),
    _createElementVNode("div", {
      class: "arrow btn arrow-right flex-center",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeStep(1)))
    }, _hoisted_6)
  ]))
}
}

})